<router-outlet></router-outlet>
<!-- Cookie consent's first layer; renders only while a choice is needed. -->
<app-cookie-banner></app-cookie-banner>
@if (showLoader()) {
  <div class="loading-overlay app-background-color flex-col align-center-center">
    <div id="loading-overlay-inner" class="flex-col align-center-center gap-30">
      <div style="margin-bottom: 30px">
        <img src="/assets/images/app-logo.svg" alt="" style="width: 150px; height: 150px;object-fit: contain">
        <h3>{{strings['app_tagline']}}</h3>
      </div>
      <!--    <div class="loading-margin heading">{{strings['initializing']}}</div>-->
      <mat-spinner [diameter]="40" [strokeWidth]="4" color="primary"></mat-spinner>
      <!--    <mat-progress-bar mode="determinate" min="0" max="100" [value]="loadingProgress" style="width: 300px" color="primary"></mat-progress-bar>-->
      <!--              <div id="loadingsubtitle" class="loading-margin" inner-h-t-m-l="{{loadingSubtitle}}"></div>-->
      <div>
        <img src="/assets/images/blueblinkone_symbol.svg" alt="" style="width: 40px; height: 40px; object-fit: contain">
        <img src="/assets/images/blueblinkone_vertical.svg" alt="" class="icon" style="width: 40px; height: 40px; object-fit: contain">
      </div>
    </div>
  </div>
}
<!-- A new version is ready (UpdateService): nothing goes on until it is loaded. -->
@if (updateRequired()) {
  <div class="update-overlay" role="alertdialog" aria-modal="true" aria-labelledby="update-title" aria-describedby="update-text">
    <div class="update-card">
      <img class="update-logo" src="/assets/images/app-logo.svg" alt="">
      <h2 id="update-title" class="update-title">{{strings['update_required_title']}}</h2>
      <p id="update-text" class="update-text">{{strings['update_required_text']}}</p>
      <button id="update-reload" mat-flat-button color="primary" class="update-button" (click)="reloadForUpdate()"
              [disabled]="reloading()">
        @if (reloading()) {
          <mat-spinner [diameter]="18" [strokeWidth]="2.5" class="update-spinner"></mat-spinner>
          {{strings['update_required_saving']}}
        } @else {
          {{strings['update_required_reload']}}
        }
      </button>
    </div>
  </div>
}

